import React from "react"

import {FieldViewSmallProps} from "../../../../render/view-small"

export default function FieldItemModelCalculatedSpentEstimate_ViewSmall(props: FieldViewSmallProps) {

    const value = Math.floor(props.field.getViewValue(props.model) || 0)

    if (!value) return null

    const excess       = value > 100
    const progressLine = excess ? Math.floor(100 * (100 / value)) : value

    const columnWidth  = (props as any).column?.width
    const showProgress = !!columnWidth && columnWidth > 100

    const classes      = Classes("ui5-progress in-ui5-field", {
        'excess-v2'                 : excess,
        "flex-row-center-center"    : showProgress
    })

    return (
        <div className={classes}>
            {showProgress &&
                <div className="progress-bg">
                    <div className="progress-line" style={{width: '{0}%'.f(progressLine)}}/>
                </div>
            }
            <div className="progress-label ui5-txt-less-important-small percentage txt-truncate">
                {"{0}%".f(value)}
            </div>
        </div>
    )
}
